import AsyncStorage from '@react-native-async-storage/async-storage';

const KEY = 'recent_users_v1';
const MAX = 5;

export type RecentUser = {
  id: string;
  name: string;
  avatarUrl: string | null;
};

export async function recordVisit(user: RecentUser): Promise<void> {
  try {
    const stored = await AsyncStorage.getItem(KEY);
    const list: RecentUser[] = stored ? JSON.parse(stored) : [];
    const updated = [user, ...list.filter((u) => u.id !== user.id)].slice(0, MAX);
    await AsyncStorage.setItem(KEY, JSON.stringify(updated));
  } catch {}
}

export async function getRecentUsers(): Promise<RecentUser[]> {
  try {
    const stored = await AsyncStorage.getItem(KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}
